import { findIndex, prop, propEq, reject, update } from 'ramda';

export const updateElementInList = (updateElement, elementList, searchBy = 'id') => {
	const foundIndex = findIndex(propEq(searchBy, prop(searchBy, updateElement)), elementList);
	return update(foundIndex, updateElement, elementList);
};

export const removeElementInList = (element, elementList, searchBy = 'id') =>
	reject(propEq(searchBy, prop(searchBy, element)), elementList);

export const findIndexElementInList = (element, elementList, searchBy = 'id') =>
	findIndex(propEq(searchBy, prop(searchBy, element)), elementList);

export default {};



// WEBPACK FOOTER //
// ./src/modules/shared/utils/listElements.js